// src/services/productivityForecastApi.js
import apiService from './apiService';

const productivityForecastApi = {
  generate: (deviceId) => apiService.post(`/productivity-forecast/${deviceId}`),
  getForDevice: (deviceId) => apiService.get(`/productivity-forecast/device/${deviceId}`),
  getAll: () => apiService.get('/productivity-forecast'), // admin only
};

export default productivityForecastApi;
